import React from "react";
import { Table } from "antd";
import { BacktestType } from "@/features/backtest";

type Props = {
  data: BacktestType.PortfolioRoundTrips[];
  isDuration: Boolean;
};

export default ({ data, isDuration }: Props) => {
  const columns = [
    {
      title: "",
      dataIndex: "index",
      key: "index"
    },
    {
      title: "All Trades",
      dataIndex: "allTrades",
      key: "allTrades",
      render: (value: number) => (isDuration ? `${value}days` : value)
    },
    {
      title: "Long Trades",
      dataIndex: "longTrades",
      key: "longTrades",
      render: (value: number) => (isDuration ? `${value}days` : value)
    },
    {
      title: "Short Trades",
      dataIndex: "shortTrades",
      key: "shortTrades",
      render: (value: number) => (isDuration ? `${value}days` : value)
    }
  ];

  return <Table dataSource={data} columns={columns} pagination={false} size={"small"}/>;
};
